import { render, staticRenderFns } from "./AddCabinet.vue?vue&type=template&id=357974ae&"
import script from "./AddCabinet.vue?vue&type=script&lang=js&"
export * from "./AddCabinet.vue?vue&type=script&lang=js&"
import style0 from "./AddCabinet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddCabinet.vue"
export default component.exports